import { makeStyles } from 'tss-react/mui';
import logo from '../wechsler_logo_w.svg';

const headerStyles = makeStyles({ uniqId: 'header' })((theme, _params, classes: Record<string, string>) => ({
  '@keyframes slideRight': {
    from: {
      opacity: 0,
      transform: 'translateX(-100px)'
    },
    to: {
      opacity: 1,
      transform: 'none'
    }
  },
  fixed: {
    position: 'fixed',
    top: 0,
    boxShadow: theme.shadows[4],
    background: theme.palette.background.paper,
    zIndex: 1000, // Zapewnia, że AppBar jest na wierzchu
    '& nav': {
      padding: theme.spacing(1, 0),
      '& ul': {
        '& li': {
          '& a': {
            color: theme.palette.text.primary,
          }
        }
      }
    }
  },
  openDrawer: {},
  header: {
    color: theme.palette.text.primary,
    '& ul li a': {
      textShadow: 'none',
    },
    [`&:not(.${classes.fixed}) ul li a`]: {
      textShadow: '0.5px 0.5px 0px #000',
    },
    background: 'none',
    boxShadow: 'none',
    transition: 'all 0.5s ease-out',
    pointerEvents: 'auto',
    position: 'fixed',
    zIndex: 1050,
    '& .MuiContainer-root': {
      padding: 0
    },
    '& > *': {
      [theme.breakpoints.down('sm')]: {
        padding: 0
      }
    },
    '& nav': {
      transition: 'all 0.5s ease-out',
    },
    [`&.${classes.fixed}`]: {
      position: 'fixed',
      top: 0,
      boxShadow: theme.shadows[4],
      background: theme.palette.background.paper,
      zIndex: 1000,
      [`& .${classes.logo}`]: {
        '& a': {
          color: theme.palette.text.primary,
        },
        '& img': {
          height: 32,
          width: 32,
        }
      },
      [`& .${classes.bar}`]: {
        [theme.breakpoints.down('md')]: {
          backgroundColor: theme.palette.text.secondary,
          '&:after, &:before': {
            backgroundColor: theme.palette.text.secondary
          }
        }
      },
      '& nav': {
        padding: theme.spacing(1, 0),
        '& ul': {
          '& li': {
            '& a': {
              color: theme.palette.text.primary,
            }
          }
        }
      },
      [`& .${classes.vDivider}`]: {
        minHeight: theme.spacing(3)
      },
      [`& .${classes.icon}`]: {
        '& svg': {
          fill: theme.palette.text.secondary
        }
      }
    },
    [`&.${classes.openDrawer}`]: {
      zIndex: 1600,
      boxShadow: 'none',
      [`& .${classes.logo}`]: {
        '& a': {
          color: theme.palette.text.secondary,
        }
      },
    }
  },
  headerContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& nav': {
      alignItems: 'center',
      padding: theme.spacing(2),
      display: 'flex',
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(2, 0),
      },
    }
  },
  logo: {
    '& a': {
      textDecoration: 'none',
      display: 'flex',
      fontSize: 16,
      color: theme.palette.text.primary,
      alignItems: 'center',
      fontWeight: 500,
      fontFamily: 'Square721DmNormalFont',
      [theme.breakpoints.down('md')]: {
        color: theme.palette.text.primary
      }
    },
    '& img': {
      transition: 'all 0.3s ease-out',
      width: 48,
      height: 48,
      marginRight: theme.spacing(),
      [theme.breakpoints.only('md')]: {
        marginLeft: theme.spacing(2)
      }
    }
  },
  logoContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  switchStyle: {
    marginLeft: theme.spacing(1),  // Możesz dostosować tę wartość według potrzeb
  },
  active: {},
  invert: {},
  navLogo: {
    [`&.${classes.invert}`]: {
      [`& .${classes.logo}`]: {
        '& a': {
          color: theme.palette.text.primary,
        }
      },
      [`& .${classes.mobileMenu}`]: {
        [`& .${classes.bar}`]: {
          [theme.breakpoints.down('md')]: {
            backgroundColor: theme.palette.text.secondary,
            '&:after, &:before': {
              backgroundColor: theme.palette.text.secondary
            },
          }
        }
      },
    }
  },
  navMenu: {
    '& > *': {
      margin: 0,
      [theme.breakpoints.up('lg')]: {
        margin: theme.spacing(0, 1),
        width: 'auto', // Zapewnienie, że szerokość jest auto, by uniknąć niepotrzebnego zawijania
      }
    },
    [`&.${classes.invert}`]: {
      '& ul': {
        '& li': {
          '& a': {
            transition: 'all 0.3s ease-out',
            color: theme.palette.text.primary,
          }
        }
      }
    },
    '& ul': {
      display: 'flex', // Dodanie flex do lepszego zarządzania elementami
      flexWrap: 'nowrap', // Zapobieganie zawijaniu elementów
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      '& li': {
        [theme.breakpoints.up('lg')]: {
          margin: theme.spacing(0, 2),
        },
        listStyle: 'none',
        position: 'relative',
        display: 'inline-block',
        '& a': {
          display: 'inline-block',
          whiteSpace: 'nowrap',
          color: theme.palette.common.white,
          marginTop: theme.spacing(0.5),
          textTransform: 'capitalize',
          fontSize: 18,
          fontWeight: theme.typography.fontWeightMedium,
          background: 'none !important',
          boxShadow: 'none',
          position: 'relative',
          padding: '6px',
          margin: theme.spacing(0, 1),
          minWidth: 0,
          '&:after': {
            content: '""',
            borderBottom: '3px solid #fff',
            width: '0%',
            position: 'absolute',
            bottom: 0,
            left: '50%',
            transition: 'all 0.2s cubic-bezier(0.42, 0.16, 0.21, 0.93)',
          },
          '&:hover, &.active': {
            '&:after': {
              content: '""',
              position: 'absolute',
              bottom: 0,
              left: 0,
              width: '100%',
              height: '3px',
              backgroundColor: theme.palette.primary.main,
              transition: 'background-color 0.3s',
            }
          }
        },
        '&[class="active"]': {
          '& a': {
            color: theme.palette.primary.light,
            '&:after': {
              borderBottomColor: theme.palette.primary.light,
              width: '60%',
              left: 8,
            },
          }
        }
      }
    }
  },
  langMenu: {
    textTransform: 'capitalize',
    '& i': {
      flagIcon: {
        width: 16,
        height: 16,
        borderRadius: '50%',
        display: 'inline-block',
        position: 'relative',
        marginRight: 5,
        top: 1,
        background: `url(${logo}) no-repeat transparent`,
        backgroundSize: '16px auto',
        '&[class="ar"]': {
          backgroundPosition: '0 3px'
        },
        '&[class="zh"]': {
          backgroundPosition: '0 -12px'
        },
        '&[class="en"]': {
          backgroundPosition: '0 -28px'
        },
        '&[class="de"]': {
          backgroundPosition: '0 -44px'
        },
        '&[class="id"]': {
          backgroundPosition: '0 -62px'
        },
        '&[class="pt"]': {
          backgroundPosition: '0 -79px'
        },
      }
    }
  },
  modeMenu: {
    textTransform: 'capitalize',
  },
  vDivider: {
    margin: theme.spacing(0, 1),
    borderLeft: `1px solid ${theme.palette.divider}`,
    height: '100%',
    transition: 'all 0.5s ease-out',
    minHeight: theme.spacing(6)
  },
  icon: {},
  setting: {
    [`& .${classes.icon}`]: {
      fontSize: 32,
      transition: 'all 0.3s ease',
      color: theme.palette.common.white,
      [`&.${classes.invert}`]: {
        color: theme.palette.text.primary
      }
    },
    [`& .${classes.active}`]: {
      transform: 'rotate(30deg)'
    }
  },
  titleMenu: {
    textTransform: 'capitalize'
  },
  bar: {},
  menu: {},
  menuOpen: {},
  paperNav: {
    width: '100%',
    [theme.breakpoints.up(680)]: {
      width: 300,
    },
  },
  mobileMenu: {
    zIndex: 1100,
    margin: theme.spacing(0, 1),
    [`& .${classes.bar}`]: {
      backgroundColor: theme.palette.text.primary,
      '&:after, &:before': {
        backgroundColor: theme.palette.text.primary
      },
    },
    '&[class*="is-active"]': {
      [`& .${classes.bar}`]: {
        backgroundColor: theme.palette.text.secondary,
        '&:after, &:before': {
          backgroundColor: theme.palette.text.secondary,
        }
      }
    }
  },
  mobileNav: {
    background: theme.palette.background.paper,
    [`& .${classes.menu}`]: {
      padding: theme.spacing(0, 2),
      overflow: 'auto',
      top: theme.spacing(15),
      width: '100%',
      position: 'absolute',
      height: 'calc(100% - 80px)',
      '& a': {
        animationName: '$slideRight',
        animationTimingFunction: 'ease'
      },
    },
    '& .MuiList-root': {
      padding: theme.spacing(0),
      '& .MuiListItem-root': {
        transition: 'background-color 0.3s ease',
        '&:hover, &.active': {
          backgroundColor: theme.palette.action.selected, // Szare tło dla aktywnego elementu
        },
        '& .MuiListItemIcon-root': {
          color: theme.palette.text.secondary, // Zmiana koloru ikon, jeśli potrzebujesz
        }
      },
    }
  },
  menuList: {
    textTransform: 'capitalize',
    '& span': {
      fontSize: 24
    }
  }
}));

// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.
export default headerStyles;